import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";

function ActionsMenu({ items, onBeforeOpen }) {
  let [rawItems] = useState(items.map((i) => ({ ...i })));
  let [loadedItems, setLoadedItems] = useState(items.map((i) => ({ ...i })));
  let [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoadedItems(items.map((i) => ({ ...i })));
    setLoaded(false);
  }, [items]);

  async function fetchAsyncLinks(isOpen) {
    // Call onBeforeOpen when opening the menu
    if (isOpen && onBeforeOpen) {
      const canOpen = await onBeforeOpen();
      if (!canOpen) return; // Don't open if check fails
    }
    
    if (loaded) return;
    for (let i = 0; i < rawItems.length; i++) {
      let item = rawItems[i];
      if (item.asyncLink) {
        item.asyncLink()
          .then((link) => {
            setLoadedItems((items) => {
              let newItems = [...items];
              newItems[i].link = link;
              return newItems;
            });
          })
          .catch((error) => {
            console.error("Error in asyncLink:", error);
            // Mark the item as having an error so it can be disabled
            setLoadedItems((items) => {
              let newItems = [...items];
              newItems[i].error = true;
              return newItems;
            });
          });
      }
    }
    setLoaded(true);
  }

  return (
    <>
      <Dropdown onToggle={fetchAsyncLinks}>
        <Dropdown.Toggle>Actions</Dropdown.Toggle>
        <Dropdown.Menu>
          {loadedItems.map((item, index) => {
            if (item.divider) {
              // No divider as first or last item
              if (index === 0 || index === items.length - 1) return null;
              // No double dividers
              if (index > 0 && items[index - 1].divider) return null;
              return <Dropdown.Divider key={"item-" + index} />;
            }

            if (item.link) {
              if (!item.externalLink)
                return (
                  <Dropdown.Item as={Link} to={item.link} key={"item-" + index}>
                    {item.label}
                  </Dropdown.Item>
                );
              else
                return (
                  <Dropdown.Item
                    as="a"
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                    key={"item-" + index}
                  >
                    {item.label}
                  </Dropdown.Item>
                );
            }

            return (
              <Dropdown.Item
                onClick={item.onClick}
                disabled={item.disabled || (item.asyncLink && !item.link) || item.error}
                key={"item-" + index}
              >
                {item.label}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

export default ActionsMenu;
